module.exports = __webpack_public_path__ + "img/smart_carousel_3.dde17e6e.png";